import { inject, observer } from 'mobx-react';
import { ChatConversationsEmptyState } from 'Modules/conversation/listConversation/components/chatConversationsEmptyState';
import * as React from 'react';
import { STORE_UI } from '../../constants/stores';
import { UiStore } from '../../stores';

/**
 * Welcome screen
 */

class ContextContentLoadingPanel extends React.Component<{ ui: UiStore }> {
  render() {
    const url = window.location.pathname;
    const modalOpened = this.props.ui.groupModalOpen;
    const showWelcome = [
      '/chat/conversation',
      '/voicemail',
      '/fax',
      'video-app',
      '/chat/details',
      '/chat/adHocGroup',
      'settings',
      'directory',
    ].some((path) => url.includes(path));

    //should be hidden for conversations, voicemails, fax ..
    if (showWelcome || modalOpened) {
      return <React.Fragment></React.Fragment>;
    }

    return <ChatConversationsEmptyState />;
  }
}
export default inject(STORE_UI)(observer(ContextContentLoadingPanel));
